import angular from 'angular';
import '../core.module';

export const REALTIME_EVENT = 'REALTIME_EVENT';
export const REALTIME_EVENT_TYPES = [
  'message.created',
  'message.updated',
  'conversation.updated',
  'conversations.removed',
  'history.progress',
  'channel.status',
  'notification.created'
];
const RECONNECT_DELAYS_MS = [1000, 2000, 5000, 10000, 30000];

class RealtimeService {
  constructor($http, $window, $timeout, $rootScope, API_BASE_URL, EventBusService) {
    this.$http = $http;
    this.$window = $window;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.API_BASE_URL = API_BASE_URL;
    this.EventBusService = EventBusService;
    this.subscribers = 0;
    this.attempt = 0;
    this.source = null;
    this.reconnectPromise = null;
  }

  connect() {
    this.subscribers += 1;
    if (this.subscribers === 1) this.open();
  }

  disconnect() {
    this.subscribers = Math.max(this.subscribers - 1, 0);
    if (this.subscribers === 0) this.close();
  }

  open() {
    this.$http
      .post(`${this.API_BASE_URL}/realtime/tickets`, {}, { silentErrors: true })
      .then(({ data }) => {
        if (!this.subscribers) return;
        const url = `${this.API_BASE_URL}/realtime/stream?ticket=${encodeURIComponent(data.ticket)}`;
        const source = new this.$window.EventSource(url);
        REALTIME_EVENT_TYPES.forEach((type) =>
          source.addEventListener(type, (message) => this.dispatch(message.data))
        );
        source.onopen = () => {
          this.attempt = 0;
        };
        source.onerror = () => this.reconnect();
        this.source = source;
      })
      .catch(() => this.reconnect());
  }

  dispatch(raw) {
    let event;
    try {
      event = JSON.parse(raw);
    } catch {
      return;
    }
    this.$rootScope.$applyAsync(() => this.EventBusService.emit(REALTIME_EVENT, event));
  }

  reconnect() {
    this.closeSource();
    if (!this.subscribers || this.reconnectPromise) return;
    const delay = RECONNECT_DELAYS_MS[Math.min(this.attempt, RECONNECT_DELAYS_MS.length - 1)];
    this.attempt += 1;
    this.reconnectPromise = this.$timeout(() => {
      this.reconnectPromise = null;
      if (this.subscribers) this.open();
    }, delay);
  }

  close() {
    if (this.reconnectPromise) this.$timeout.cancel(this.reconnectPromise);
    this.reconnectPromise = null;
    this.attempt = 0;
    this.closeSource();
  }

  closeSource() {
    if (!this.source) return;
    this.source.close();
    this.source = null;
  }
}

RealtimeService.$inject = [
  '$http',
  '$window',
  '$timeout',
  '$rootScope',
  'API_BASE_URL',
  'EventBusService'
];

angular.module('app.core').service('RealtimeService', RealtimeService);

export default RealtimeService;
